import * as yup from 'yup';
import { API as departments } from '../../departments/api';
import { API as users_nautica } from '../../users_nautica/api';
import { API as teams } from '../../teams/api';

export const FilterConf = {
  schema: yup.object({}),
  initialState: {
    value: {
      blocked: null,
      id_department: [],
      id_users_role: [],
      id_teams: [],
    },
  },
  fields: [
    {
      id: 'id_department',
      name: 'id_department',
      type: 'async_autocomplete',
      label: 'Department',
      api: departments.all,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'blocked',
      name: 'blocked',
      type: 'autocomplete',
      label: 'Status',
      options: [
        { label: 'ENABLE', id: false },
        { label: 'DISABLE', id: true },
      ],
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'id_users_role',
      name: 'id_users_role',
      type: 'async_autocomplete',
      label: 'Role',
      api: users_nautica.selectUsersRole,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'id_teams',
      name: 'id_teams',
      type: 'async_autocomplete',
      label: 'Team',
      api: teams.select,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
  query: {
    keys: [
      {
        key: 'blocked',
        value: 'blocked.id',
        operator: '$eq',
      },
      {
        key: 'id_users_nautica.id_users_nautica_departments.id_department.id',
        value: 'id_department.id',
        operator: '$eq',
      },
      {
        key: 'id_users_role.id',
        value: 'id_users_role.id',
        operator: '$eq',
      },
      {
        key: 'id_users_nautica.id_teams.id',
        value: 'id_teams.id',
        operator: '$eq',
      },
    ],
  },
};
